import {SetGetListMessanger} from './thunk/setGetListMessanger';
import {SetGetViewMessanger} from './thunk/setGetViewMessanger';
import {SetPostCreateMessanger} from './thunk/setPostCreateMessanger';
import {SetPostUpdateMessanger} from './thunk/setPostUpdateMessanger';

export const Thunks = {
    SetGetListMessanger,
    SetGetViewMessanger,
    SetPostCreateMessanger,
    SetPostUpdateMessanger
}